const Resources = {

    table_headers: [
        {
            text:   "Report Name",
            align:  "start",
            value:  "name",
            type:   "link",
        },
        {
            text:   "Select Item",
            value:  "placeholder",
            type:   "dropdown_to_fill",
        },
        {
            text:   "Run",
            static_value: "Run Report",
            type:   "link_action",
        },
    ],

    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Standard Reports",
            href: "/reports",
            arrow: "",
        },
    ],
}

export default Resources;